var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_x34_2.Italic",
    fill: "white",
    d: "m434.571 23.857v35.714c0 9.862-7.995 17.857-17.857 17.857h-70.044l-89.286 357.143h52.188c9.862 0 17.857 7.995 17.857 17.857v35.714c0 9.862-7.995 17.857-17.857 17.857h-214.286c-9.862 0-17.857-7.995-17.857-17.857v-35.714c0-9.862 7.995-17.857 17.857-17.857h70.045l89.286-357.143h-52.187c-9.862 0-17.857-7.995-17.857-17.857v-35.714c0-9.862 7.995-17.857 17.857-17.857h214.286c9.861 0 17.855 7.995 17.855 17.857z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.037b32639eb84525d28d72df1eb76b08.svg";
export { ForwardRef as ReactComponent };